import { Link } from 'react-router-dom';
import { HiOfficeBuilding, HiUsers, HiMap } from 'react-icons/hi';

export const HomePage = () => {
  return (
    <div className="container mx-auto p-8">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white">AIU Directory</h1>
        <p className="mt-2 text-lg text-gray-600 dark:text-gray-400">
          Contact information for Allegheny County school districts, career and technical centers, and jointures.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        <Link to="/leas" className="group block p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md hover:shadow-lg hover:border-blue-300 dark:hover:border-blue-600 transition-all">
          <div className="flex items-center justify-center w-16 h-16 mb-4 bg-blue-100 dark:bg-blue-900 rounded-lg group-hover:bg-blue-200 dark:group-hover:bg-blue-800 transition-colors">
            <HiOfficeBuilding className="w-10 h-10 text-blue-600 dark:text-blue-400" />
          </div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">Organizations</h2>
          <p className="text-gray-600 dark:text-gray-400">Browse and manage LEAs, CTCs, and schools</p>
        </Link>

        <Link to="/search" className="group block p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md hover:shadow-lg hover:border-blue-300 dark:hover:border-green-600 transition-all">
          <div className="flex items-center justify-center w-16 h-16 mb-4 bg-green-100 dark:bg-green-900 rounded-lg group-hover:bg-green-200 dark:group-hover:bg-green-800 transition-colors">
            <HiUsers className="w-10 h-10 text-green-600 dark:text-green-400" />
          </div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white group-hover:text-green-600 dark:group-hover:text-green-400 transition-colors">Search Contacts</h2>
          <p className="text-gray-600 dark:text-gray-400">Find administrators, staff, and board members</p>
        </Link>

        <Link to="/map" className="group block p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md hover:shadow-lg hover:border-blue-300 dark:hover:border-purple-600 transition-all">
          <div className="flex items-center justify-center w-16 h-16 mb-4 bg-purple-100 dark:bg-purple-900 rounded-lg group-hover:bg-purple-200 dark:group-hover:bg-purple-800 transition-colors">
            <HiMap className="w-10 h-10 text-purple-600 dark:text-purple-400" />
          </div>
          <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors">Interactive Map</h2>
          <p className="text-gray-600 dark:text-gray-400">Explore districts and schools geographically</p>
        </Link>
      </div>
    </div>
  );
};
